import { Icon } from '@iconify/react';
import {
  Autocomplete,
  Box,
  Button,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { styled } from '@mui/system';
import { BackgroundModal } from 'components/CashModal/CashModal';
import React, { useState } from 'react';
import closeIcon from '@iconify/icons-eva/close-outline';
import useDebounce from 'hook/useDebounce';
import useQuery from 'hook/useQuery';
import { API_PATH } from 'common/constants/services';
import UserSimpleInfo from 'model/UserSimpleInfo';
import { Pagination } from 'model/Pagination';
import useMutation, { METHOD } from 'hook/useMutation';
import { useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { RootStyle } from './style';

interface IProps {
  isOpen: boolean;
  close: () => void;
}
const Container = styled('div')`
  width: 474px;
  background-color: white;

  position: absolute;
  width: 474px;
  left: calc(50% - 474px / 2);
  top: calc(50% - 476px / 2);

  border-radius: 12px;
`;

export function NewCoachModal({ isOpen, close }: IProps) {
  const [nickname, setNickname] = useState('');
  const [userId, setUserId] = useState<number | undefined>(undefined);
  const [name, setName] = useState('');
  const nicknameDebounce = useDebounce(nickname, 200);
  const queryClient = useQueryClient();
  const userListQuery = useQuery<Pagination<UserSimpleInfo>>(
    API_PATH.USER_FIND,
    {
      nickname: nicknameDebounce,
    },
  );
  const addMutation = useMutation(API_PATH.COACHES, {
    method: METHOD.POST,
    onSuccess: () => {
      queryClient.invalidateQueries([API_PATH.COACHES]);
      toast.success('코치 등록 완료');
    },
    onError: (e) => {
      toast.error(e.response?.data.message);
    },
  });
  const userOption = userListQuery.getQuery.data?.data.results.map((user) => ({
    id: user.id,
    label: user.nickname,
  }));
  return isOpen ? (
    <BackgroundModal isOpen={isOpen} onClick={close}>
      <Container
        onClick={(event: any) => {
          event.stopPropagation();
        }}
      >
        <Stack direction='row' padding={3}>
          <Box flex={1}>
            <Typography fontSize={22} fontWeight={700}>
              새로운 코치
            </Typography>
          </Box>
          <Icon icon={closeIcon} fontSize={24} onClick={close} />
        </Stack>
        <Stack padding={3} direction='column' spacing={2}>
          <Box width='100%'>
            <TextField
              fullWidth
              id='outlined-helperText'
              label='코치 이름(구분용)'
              defaultValue=''
              placeholder='코치이름을 입력하세요'
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Box>
          <Box width='100%'>
            <Autocomplete
              disablePortal
              fullWidth
              id='combo-box-demo'
              options={userOption || []}
              // value=''
              onChange={(event, newInputValue, reason) => {
                setUserId(newInputValue?.id);
                console.log(newInputValue, reason);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  label='짐워크 닉네임 검색'
                  onChange={(e) => setNickname(e.target.value)}
                />
              )}
            />
          </Box>
        </Stack>
        <Stack padding={3}>
          <Button
            variant='contained'
            fullWidth
            disabled={name === '' || userId === undefined}
            onClick={async () => {
              await addMutation.mutateAsync({
                user_id: userId,
                name,
              });
              close();
            }}
          >
            추가하기
          </Button>
        </Stack>
      </Container>
    </BackgroundModal>
  ) : null;
}
